import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { Link } from "react-router-dom";

import secondClosetLogo from "../../../public/scIcon.png";

/**
 * Config
 */
import { navigationLinks } from "../../../config/navigationConfig";
import { clearScroll } from "../../../helperFunctions";

import { Button, Dropdown, Menu, message } from "antd";
import { NavigationMenu } from "../../NavMenu";
import packageInfo from "../../../../package.json";
import { FeaturePreviewModal } from "../../FeaturePreviewModal";
import { signOut } from "../../../actions";

// Helpers
import { capitalize } from "lodash-es";
import FacilitiesSelect from "components/FacilitiesSelect";

class Header extends React.Component {
  constructor() {
    super();
    this.state = {
      openedNav: undefined,
      featurePreviewVisible: false,
    };
  }

  onLogOut() {
    this.props.signOut();
  }

  clickMenuItem(link) {
    return () => {
      clearScroll();
      this.props.history.push(link);
    };
  }

  handleNavbarToggle = () => {
    const { openedNav } = this.state;
    this.setState({ openedNav: !openedNav });
  };

  renderNavigationMenu = () => {
    const { auth, history } = this.props;

    const dropdownLinks = navigationLinks.filter(
      (link) => !link.subroles.length || link.subroles.includes(auth.user.subrole)
    );
    const currentPathname = history.location.pathname;
    return (
      <NavigationMenu
        links={dropdownLinks}
        isDesktop={false}
        currentPathname={currentPathname}
        handleNavbarToggle={() => this.handleNavbarToggle()}
        history={history}
      />
    );
  };

  buildFacilitySelector = () => {
    const { setActiveFacility, activeFacility } = this.props;
    const handleSelect = (facility) => {
      setActiveFacility(facility);
      message.success(`You are now viewing ${facility.name}`, 2);
    };
    return (
      <div className="header-facility-selector inl-flex-row">
        <p className="facility-label">Facility: </p>
        <FacilitiesSelect onSelect={handleSelect} selectedValue={activeFacility.name} />
      </div>
    );
  };

  render() {
    const { auth, history } = this.props;
    const { openedNav, featurePreviewVisible } = this.state;
    const userDetailsMenu = (
      <Menu onClick={() => this.handleNavbarToggle()}>
        {/* <Menu.Item
          className="ant-dropdown-menu-item"
          title="Feature Preview"
          eventKey={3.0}
          onClick={() => this.setState({ ...this.state, featurePreviewVisible: true })}
        >
          Feature Preview
        </Menu.Item> */}
        <Menu.Item
          className="ant-dropdown-menu-item"
          title="Account Details"
          eventKey={3.1}
          onClick={() => history.push("/account")}
        >
          Account Details
        </Menu.Item>
        <Menu.Item className="ant-dropdown-menu-item" title="Log Out" eventKey={3.3} onClick={this.onLogOut.bind(this)}>
          Log out
        </Menu.Item>
      </Menu>
    );

    const userName =
      capitalize(auth.user.first_name.replace(/\[.*?\]\s/g, "").charAt(0)) + capitalize(auth.user.last_name.charAt(0));
    return (
      <div className={openedNav ? "topBar opened" : "topBar"}>
        <div className="topBar-container">
          <div className="inline-block w-25">
            <div className="brandLogo">
              <Link className="logoLink" to="/">
                <img src={secondClosetLogo} alt="logo" width="50px" height="50px" />
              </Link>
            </div>
            <div className="brandVersion">
              {packageInfo.version}
              <span className="navbar-env">{process.env.REACT_APP_ENV.toUpperCase()}</span>
            </div>
          </div>
          <div className="inline-block w-75 text-right">
            {this.buildFacilitySelector()}
            <button
              type="button"
              className={openedNav ? "menu-toggle is-active" : "menu-toggle"}
              onClick={() => this.handleNavbarToggle()}
            />
            <Dropdown overlay={userDetailsMenu} trigger={["click"]}>
              <Button className="navbar-account-btn">{userName}</Button>
            </Dropdown>
          </div>
        </div>
        <div className="navbar-mobile-menu">
          <div className="navbar-mobile-container">
            <div className="inline-block w-50">
              {packageInfo.version}
              <span className="navbar-env">{process.env.REACT_APP_ENV.toUpperCase()}</span>
            </div>
            <div className="inline-block w-50 text-right">
              <Dropdown overlay={userDetailsMenu} trigger={["click"]}>
                <Button className="navbar-account-btn">{userName}</Button>
              </Dropdown>
            </div>
          </div>
          {this.renderNavigationMenu()}
          <FeaturePreviewModal
            visible={this.state.featurePreviewVisible}
            onCancel={() => this.setState({ ...this.state, featurePreviewVisible: false })}
          />
        </div>
      </div>
    );
  }
}

export default connect(() => {}, { signOut })(Header);

Header.propTypes = {
  history: PropTypes.object.isRequired,
  auth: PropTypes.object,
  activeFacility: PropTypes.object.isRequired,
  facilityList: PropTypes.arrayOf(PropTypes.object),
  signOut: PropTypes.func.isRequired,
  setActiveFacility: PropTypes.func.isRequired,
};
